module.exports = __webpack_public_path__ + "static/media/page_not.5463fdd5.svg";